module.exports = __webpack_public_path__ + "static/PRE_Screen-9f97bc1991946f18abb59ad69fee8e3b.png";